/**
 * Smooth Scroll when click on link
 */
import smoothscroll from 'smoothscroll-polyfill';

const supportScrollBehavior = CSS.supports('scroll-behavior', 'smooth');
if (!supportScrollBehavior) {
  smoothscroll.polyfill();
  const links = Array.from(document.links)
  const linksAnchors = links.filter((link) => {
    const url = new URL(link);
    return url.hash !== '';
  });

  for (let index = 0; index < linksAnchors.length; index++) {
    const el = linksAnchors[index];
    const url = el.getAttribute('href');
    const hash = url.substring(url.indexOf('#') + 1);

    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      const topHeight = window.getComputedStyle(document.documentElement).getPropertyValue('--top-height');
      const tocHeight = window.getComputedStyle(document.documentElement).getPropertyValue('--toc-height');
      const offset = parseInt(topHeight) - parseInt(tocHeight);
      const target = document.getElementById(hash);
      window.scrollTo({top: target.offsetTop + offset, behavior: 'smooth'});
    })
  }
}
